import { useEffect } from 'react';
import { useActionsCommandPalette } from '@atlassian/jira-command-palette';

declare global {
	interface Window {
		JIRA_COMPAL?: {
			open?: () => void;
		};
	}
}

export const useCompalBridge = () => {
	const { open } = useActionsCommandPalette();

	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.JIRA_COMPAL = {
				open,
			};
		}
		return () => {
			if (typeof window !== 'undefined') {
				window.JIRA_COMPAL = undefined;
			}
		};
	}, [open]);
};
